import { Injectable } from "@angular/core";
import { EventsService } from "../event/event.service";

@Injectable({
  providedIn: "root",
})
export class LogService {
  constructor(private events: EventsService) {}
  log(data: any, sourceForId?: any) {
    try {
      if (!data.name) {
        data.name = "appPurchaseLog";
      }
      data.id = this.extractId(sourceForId);
      this.events.publish("event:log", data);
    } catch (e) {
      console.error("Error in log function", e);
    }
  }

  extractId(source: any) {
    if (!source) {
      return "UnknownId";
    }

    if (typeof source === "object") {
      const possibleIdProps = ["transactionId", "id", "purchaseToken"];
      for (const prop of possibleIdProps) {
        if (source[prop]) {
          return source[prop];
        }
      }
    } else if (typeof source === "string") {
      return source;
    }

    return "UnknownId";
  }
}
